<template>
    <div v-if="cartStore.currentOrderData.customfields_data && cartStore.currentOrderData.customfields_data[eventID]">
      <InputSelect
      v-if="customField.fieldType === 'dropdown'"
      :options="customField.fieldlist?.values?.map(x => ({ label: x, value: x })) || []"
      :placeholder="placeholderString"
      class="w-full"
      :id="customField.name"
      v-model="customField.value"
      :name="customField.name"
      :required="isRequired"
      :rules="setRules(customField, 'string', isRequired)"
      />

      <InputDate
      v-if="customField.fieldType === 'datefield'"
      :placeholder="placeholderString"
      class="w-full"
      :id="customField.name"
      v-model="customField.value"
      :name="customField.name"
      :required="isRequired"
      :rules="setRules(customField, 'string', isRequired)"
      :min-date="new Date(customField.customFieldData.minDate * 1000)"
      :max-date="new Date(customField.customFieldData.maxDate * 1000)"
      :close-on-select="true"
      />

      <InputCPR
      v-if="customField.fieldType === 'cprnumber'"
      :placeholder="placeholderString"
      :id="customField.name"
      v-model="customField.value"
      class="w-full"
      :name="customField.name"
      :required="isRequired"
      :rules="setRules(customField, 'string', isRequired)"
      />

      <InputText
      v-if="customField.fieldType === 'textfield'"
      :placeholder="placeholderString" 
      class="w-full"
      :type="'text'"
      :id="customField.name"
      v-model="customField.value"
      :required="isRequired"
      :rules="setRules(customField, 'string', isRequired)"
      :name="customField.name"
      />

      <InputTextarea
      v-if="customField.fieldType === 'textarea'"
      :placeholder="placeholderString" 
      class="w-full"
      :id="customField.name"
      v-model="customField.value"
      :required="isRequired"
      :rules="setRules(customField, 'string', isRequired)"
      :name="customField.name"
      />

      <InputCheckbox
      v-if="customField.fieldType === 'checkbox'"
      class="w-full"
      :id="customField.name"
      v-model="customField.value"
      :name="customField.name"
      :label="placeholderString"
      :required="isRequired"
      :rules="setRules(customField, 'boolean', isRequired)"
      />

      <div v-if="customField.fieldType === 'radio'" class="flex flex-col gap-2">
      <InputRadio
          v-for="(option, index) in customField.fieldlist?.values || []"
          :key="option"
          :hide-error="index !== (customField.fieldlist?.values?.length || 1) - 1"
          :label="placeholderString"
          :value="option"
          v-model="customField.value"
          :name="customField.name"
          :id="slugify(`${customField.name}-${option}`)"
          class="w-full"
          :rules="setRules(customField, 'string', isRequired)"
          :required="isRequired"
      />
      </div>
    </div>
</template>
<script setup lang="ts">

  import * as yup from 'yup';

  import { useCartStore } from '@/stores/cart';
  import type { CustomFieldOrderDataEntry } from '@/types';
  import { getRules } from '@/utils/customFieldRules';
  import { slugify } from '@/utils/slugify';  
  import { computed } from 'vue';

  import InputCheckbox from '../ui/inputs/InputCheckbox.vue';
  import InputCPR from '../ui/inputs/InputCPR.vue';
  import InputDate from '../ui/inputs/InputDate.vue';
  import InputRadio from '../ui/inputs/InputRadio.vue';
  import InputSelect from '../ui/inputs/InputSelect.vue';
  import InputText from '../ui/inputs/InputText.vue';
  import InputTextarea from '../ui/inputs/InputTextarea.vue';

  const cartStore = useCartStore();

    const props = defineProps<{
        type: 'addon' | 'ticket';
        fieldName: string;
        ticketId: number | undefined;
        eventID: string;
    }>();
  
  function setRules(customField: CustomFieldOrderDataEntry, fieldType: 'string' | 'number' | 'boolean', required?: boolean) {
    const rules: yup.AnySchema | undefined  = getRules(customField, fieldType, required);
    cartStore.setCustomFieldRule(props.fieldName, rules);
    return rules;
  }
  
  if(!cartStore.currentOrderData.customfields_data || !cartStore.currentOrderData.customfields_data[props.eventID] || !cartStore.currentOrderData.customfields_data[props.eventID][props.fieldName]) {
    throw new Error(`Custom field data not found for eventID: ${props.eventID}, fieldName: ${props.fieldName}`);
  }
  const customField = cartStore.currentOrderData.customfields_data[props.eventID][props.fieldName];

  let placeholderString = " ";
  placeholderString = customField.customFieldData.description ? customField.customFieldData.description : placeholderString;
  placeholderString = customField.customFieldData.long_description ? customField.customFieldData.long_description : placeholderString;

  //computed value of if field is required
  const isRequired = computed(() => {
    if(customField.fieldType === 'checkbox') {
      return customField.customFieldData.must_be_checked;
    }
    return !customField.customFieldData.empty_ok;
  });

  console.log('Rendering CheckoutCustomField with props:', props);
  console.log('Custom field data:', customField);

  if(!customField) {
    throw new Error(`Custom field data not found for eventID: ${props.eventID}, fieldName: ${props.fieldName}`);
  }


</script>